<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="options"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök momssats</em>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';

export default {
    name: 'VatRateFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
    },
    data() {
        return {
            options: [
                {
                    id: 25,
                    label: '25%',
                    account: 3150,
                },
                {
                    id: 12,
                    label: '12%',
                    account: 3160,
                },
                {
                    id: 6,
                    label: '6%',
                    account: 3162,
                },
                {
                    id: 0,
                    label: '0%',
                    account: 3151,
                },
            ],
        };
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>
